// extracted by mini-css-extract-plugin
export var active = "_e1-2";
export var recordingDot = "_e1-1";
export var recordingIndicator = "_e1-0";